import AbstractProvidedClass from "../../../shared/AbstractProvidedClass";

export default class ChangeCanopyStyleAction extends AbstractProvidedClass {
    constructor(provider, element, newStyle) {
        super(provider);
        this.element = element;
        this.newStyle = newStyle;
        this.oldStyle = element.canopyStyle;
        this.oldSeed = element.canopySeed;
        this.newSeed = null;
    }

    update() {}

    finish() {
        if (this.oldStyle === this.newStyle) {
            this.actions.discard();
            return;
        }
        this._apply(this.newStyle, null);
        this.newSeed = this.element.canopySeed;
        this.actions.finish();
    }

    undo() {
        this._apply(this.oldStyle, this.oldSeed);
    }

    redo() {
        this._apply(this.newStyle, this.newSeed);
    }

    _apply(style, seed) {
        this.element.canopyStyle = style; // replaces style instance, clears points
        this.element.canopySeed = seed;
        this.element.generateCanopyPoints();
    }
}
